<template>
  <div>
    <div class="head__wrapper">
      <span class="title-text">{{
        $l('title_text_proof_product') || '打样产品面料'
      }}</span>
      <el-button
        type="success"
        plain
        size="mini"
        class="ml-3"
        @click="onOpenAddProductWindow"
        v-if="!disabled"
        >{{ $l('btn_add_product') || '新增产品' }}</el-button
      >

      <el-button
        type="primary"
        plain
        size="mini"
        class="ml-3"
        v-if="!disabled && allow('K')"
        >{{
          $l('btn_choose_for_customer_product') || '从客户选品选择'
        }}</el-button
      >
    </div>
    <div v-for="item in sampleList" :key="item.proofingSampleCode">
      <CardInfo
        ref="cardInfo"
        :disabled="disabled"
        :item="item"
        @del="onDelProduct"
        @edit="onEditProduct"
        @reload="getData"
      />
    </div>
    <AddProductWindow
      v-if="addProductWindowOption.visible"
      :visible="addProductWindowOption.visible"
      :title="addProductWindowOption.title"
      :proofingCode="addProductWindowOption.proofingCode"
      :proofingSampleCode="addProductWindowOption.proofingSampleCode"
      :disabled="disabled"
      @close="onCloseAddProductWindow"
      @reload="getData"
    ></AddProductWindow>
  </div>
</template>
<script>
import CardInfo from './card.vue'
import EditLoading from '@/mixins/edit-loading'
import AddProductWindow from './add-product-window'
export default {
  components: { CardInfo, AddProductWindow },
  mixins: [EditLoading],
  props: {
    proofingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      addProductWindowOption: {
        visible: false,
        title: '新增打样产品',
        proofingCode: '',
        proofingSampleCode: '',
      },
      sampleList: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.proofingCode) {
        this.$api
          .customerProofingSampleListApi({
            proofingCode: this.proofingCode,
          })
          .then((res) => {
            this.sampleList = res?.body?.data || []
          })
      }
    },
    onOpenAddProductWindow() {
      this.addProductWindowOption.visible = true
      this.addProductWindowOption.proofingCode = this.proofingCode
      this.addProductWindowOption.title =
        this.$l('dialog_title_add_product') || '新增打样产品'
    },
    onCloseAddProductWindow() {
      this.addProductWindowOption.visible = false
      this.addProductWindowOption.proofingSampleCode = ''
      this.addProductWindowOption.proofingCode = ''
      this.getData()
      this.reloadCardInfo()
    },
    reloadCardInfo() {
      const cardInfo = this.$refs.cardInfo || []
      for (let i = 0; i < cardInfo.length; i++) {
        cardInfo[i]?.reloadTable()
      }
    },
    async onDelProduct({ proofingSampleCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .customerProofingSampleDelApi({ proofingSampleCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
    onEditProduct({ proofingSampleCode }) {
      this.addProductWindowOption.visible = true
      this.addProductWindowOption.proofingCode = this.proofingCode
      this.addProductWindowOption.proofingSampleCode = proofingSampleCode
      this.addProductWindowOption.title =
        this.$l('dialog_title_edit_product') || '编辑打样产品'
    },
  },
}
</script>
<style lang="scss" scoped>
.head__wrapper {
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .title-text {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
  }
}
</style>
